import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exmintion',
  templateUrl: './exmintion.component.html',
  styleUrls: ['./exmintion.component.css']
})
export class ExmintionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
